export default {
  default: () => import("/home/forge/efxpp.ch/layouts/default.vue").then(m => m.default || m)
}